import type { ParsedUrlQuery } from "querystring";

/**
 * Function to decode a jwt token and return an object containing data.
 * @param {ParsedUrlQuery | any} tokenObject
 *   query object from nextjs router
 *
 * @returns { token, data }
 * Token is what is found in the url
 * data is the deconstructed token
 */
export const parseJwt = <T>(tokenObject: ParsedUrlQuery): { token: string; data: T } => {
  if (!tokenObject) {
    return { token: "", data: {} as T };
  }
  let token;
  if ("token" in tokenObject) {
    token = tokenObject["token"];
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    const result = JSON.parse(window.atob(base64));
    return {
      token,
      data: result,
    };
  }
};
